<div class="overlay" (click)="closeModal()">
    <div class="modal-content">
        <div class="image-container" #imageContainer (click)="$event.stopPropagation()">
            <!-- IMMAGINE NON ZOOMMABILE -->
            <img #image [src]="urlServerLaraApiMultimedia+currentSrc" />
            <!-- Immagine zoomabile -->
            <!-- <img #image [src]="urlServerLaraApiMultimedia+currentSrc" alt="Zoomable image" [style.transform]="'scale(' + zoomLevel + ')'"/>  -->

            <button class="btn btn-danger" style="position: absolute; top: 5px; right: 5px; opacity: 0.9;"
                (click)="closeModal()">
                <i class="bi bi-x" style="color: white;"></i>
            </button>
        </div>
    </div>
</div>